import Header from "../component/layout/Header";
import Layout from "../component/layout/Layout";
import HomeBackground from '../assets/images/HomeBackground.png';
import whitebg from "../assets/images/white_bg.png"
import PartnerLogin from "../component/PartnerCourseComponent/PartnerLogin";
import poster from "../assets/images/referAndEarn/poster.png";
const ReferAndEarn = () => {
    return (
        <>
            <Layout tab={2}>
                <div style={{ height: '40vh', width: '99vw', position: 'relative', backgroundImage: `url(${HomeBackground})`, backgroundSize: 'cover', backgroundPosition: 'center', overflow: 'hidden', margin: "auto" }}>
                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgb(11 49 97 / 88%)' }}></div>



                    <div style={{ position: 'relative', zIndex: 2, }}>

                        <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "40vh", color: "white" }}>
                            <h1 style={firstSectionStyle.h1}>REFER & EARN</h1>
                        </div>
                    </div>

                </div >

                <div className="row">
                    <img src={poster} style={{ height: "80vh", width: "100vw" }} />
                </div>



            </Layout>

        </>
    )
}

const firstSectionStyle = {
    h1: {
        fontFamily: 'Playfair Display, serif',
        fontSize: '6rem',
        fontWeight: 'bold',
    }
}

const buttonStyle = {
    backgroundColor: "#FFA800", // Orange color
    color: "#FFFFFF", // White text
    border: "none",
    borderRadius: "20px", // Rounded corners
    padding: "6px 14px", // Adjust padding for size
    fontSize: "1.3rem", // Adjust font size
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow
};
export default ReferAndEarn;